import { useEffect, useState } from 'react';

import {
  measureViewportHeight,
  VIEWPORT_HEIGHT_REFRESH_EVENT,
} from 'src/common/utils/viewportHeight';

export function useViewportHeight(): number | null {
  const [height, setHeight] = useState<number | null>(null);

  useEffect(() => {
    let rafId = 0;

    const updateHeight = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const measured = measureViewportHeight();
        if (measured !== null) {
          setHeight(measured);
        }
      });
    };

    updateHeight();

    window.addEventListener('resize', updateHeight);
    window.addEventListener(VIEWPORT_HEIGHT_REFRESH_EVENT, updateHeight);
    window.visualViewport?.addEventListener('resize', updateHeight);
    window.visualViewport?.addEventListener('scroll', updateHeight);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', updateHeight);
      window.removeEventListener(VIEWPORT_HEIGHT_REFRESH_EVENT, updateHeight);
      window.visualViewport?.removeEventListener('resize', updateHeight);
      window.visualViewport?.removeEventListener('scroll', updateHeight);
    };
  }, []);

  return height;
}
